import React from 'react';

export interface PDFDisplayProps {
  pdf: string;
  className?: string;
}

const PDFDisplay: React.FC<PDFDisplayProps> = ({ pdf, className = '' }) => {
  const pdfUrl = `${pdf}#toolbar=1&navpanes=0&scrollbar=0&statusbar=0&messages=0&view=FitH&transparent=1`;

  return (
    <div className={`flex flex-col gap-4 ${className}`} data-testid="atom-pdf-viewer">
      <div className="relative rounded-lg border border-gray-200 bg-white">
        <iframe src={pdfUrl} className="h-[600px] w-full rounded-lg" title="PDF viewer" data-testid="atom-pdf-viewer-frame" />
      </div>
    </div>
  );
};

export default PDFDisplay;
